module.exports = __webpack_public_path__ + "static/media/img3-3.23bc0621.png";